/**
 * LEGACY_DECOMMISSIONED (May 22, 2026)
 * Part of the legacy upload subsystem. Frozen. Do not extend.
 * Replacement: separate Video Analysis Engine (see VAE_CLEAN_ROOM_ARCHITECTURE.md).
 *
 * PickerRecoveryCallout — visible "Photos handoff missed" callout.
 *
 * P0 (May 20, 2026 — production retest failed):
 *   When the parent surface re-mounts/re-focuses with no onChange
 *   fired and no files staged, this is the visible recoverable
 *   surface the operator sees. Doctrine: "user is never dumped
 *   back to the start screen".
 *
 * Shared so every upload entry point surfaces the same calm
 * recoverable behaviour:
 *   • clear acknowledgement that a handoff was detected
 *   • one-tap Re-pick CTA
 *   • dismissible
 *
 * Doctrine-locked phrasing kept consistent across the platform.
 */
import { AlertCircle, Plus, X } from "lucide-react";

export default function PickerRecoveryCallout({
  onRePick,
  onDismiss,
  source,
  testid = "picker-recovery-callout",
}) {
  return (
    <div
      data-testid={testid}
      data-source={source || ""}
      className="rounded-xl border border-amber-500/40 bg-amber-500/10 p-3 space-y-2"
      role="alert"
    >
      <div className="flex items-center gap-2">
        <AlertCircle className="w-4 h-4 text-amber-300 flex-none" />
        <p className="text-[12px] font-extrabold text-amber-100">
          We saw you tap Photos, but your selection didn't come back.
        </p>
      </div>
      <p className="text-[11px] text-amber-100/85 leading-snug">
        Sometimes iPhone returns to this screen without sending the
        video through. Your clip is still on your device — tap below
        to pick it again. You won't have to start over.
      </p>
      <div className="flex items-center gap-2 pt-0.5">
        <button
          type="button"
          data-testid={`${testid}-repick`}
          onClick={onRePick}
          className="h-9 px-3 rounded-lg bg-amber-400 hover:bg-amber-300 text-[#050505] text-[12px] font-extrabold flex items-center gap-1.5"
        >
          <Plus className="w-3.5 h-3.5" />
          Re-pick from Photos
        </button>
        <button
          type="button"
          data-testid={`${testid}-dismiss`}
          onClick={onDismiss}
          className="h-9 px-3 rounded-lg border border-amber-500/40 text-amber-100 text-[12px] font-extrabold hover:bg-amber-500/10 flex items-center gap-1.5"
        >
          <X className="w-3.5 h-3.5" />
          Dismiss
        </button>
      </div>
    </div>
  );
}
